/* eslint-disable @typescript-eslint/no-non-null-assertion */
// By path, not through the '@components' barrel: that barrel re-exports this very file, and a
// module in the middle of a cycle can be reached before its imports have been initialised.
import { SharedSpinner } from '../Loading/SharedSpinner';
import { useStore } from '@stores';
import { useEffect } from 'react';

const Logout = () => {
  const { authenticationStore } = useStore();

  useEffect(() => {
    authenticationStore!.logout();

    // A full load rather than a router navigation: the stores, timers and sockets of the
    // session being left behind would otherwise carry straight on into the login screen.
    window.location.href = '/login';
  }, [authenticationStore]);

  return <SharedSpinner loading />;
};

export default Logout;
